// extracted by mini-css-extract-plugin
export var lg = "_28-4";
export var md = "_28-3";
export var sm = "_28-2";
export var xs = "_28-1";
export var xxs = "_28-0";